<template>
  <div class="plan">
    <h3>{{ plan.title }}</h3>
    <p class="price">{{ plan.price }}</p>
    <ul>
      <li v-for="(feature, index) in plan.features" :key="index">
        <component :is="feature.isIncluded ? 'CheckIcon' : 'XIcon'" />
        {{ feature.text }}
      </li>
    </ul>
    <BaseButton :onClick="handlePlanClick">{{ plan.buttonText || 'Choose' }}</BaseButton>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import CheckIcon from "@/components/CheckIcon.vue";
import XIcon from "@/components/XIcon.vue";
import BaseButton from "@/components/BaseButton.vue";

export const PLAN_NAMES = {
  FREE: 'free',
  PREMIUM: 'premium',
  BOTH: 'both'
};

export default defineComponent({
  name: "OnePricingPlan",
  components: {
    CheckIcon,
    XIcon,
    BaseButton
  },
  props: {
    plan: {
      type: Object,
      required: true,
      validator: (prop) => {
        return prop.title && 
               prop.price && 
               Array.isArray(prop.features) && 
               prop.planName && 
               Object.values(PLAN_NAMES).includes(prop.planName);
      }
    },
    onPlanClick: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const handlePlanClick = () => {
      props.onPlanClick(props.plan);
    };

    return {
      handlePlanClick
    };
  }
});
</script>

<style scoped>
.plan {
  background-color: #e7e7e7;
  border-radius: 8px;
  padding: 30px;
  width: 380px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  position: relative;
  text-align: center;
  height: 24rem;
  display: flex;
  flex-direction: column;
}

.plan h3 {
  margin-bottom: 15px;
  font-size: 25px;
  color: black;
}

.plan p {
  margin-bottom: 20px;
}

.price {
  font-size: 32px;
  margin-bottom: 20px;
  font-weight: bold;
}

.plan ul {
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
  margin-bottom: 20px;
  line-height: 1.6;
  font-size: 16px;
}

.plan ul li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  line-height: 1.5;
}

.plan ul li .icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.plan :deep(.btn) {
  margin-top: auto;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .plan {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    padding: 24px;
    height: auto;
    min-height: auto;
    position: relative;
  }
  
  .plan h3 {
    font-size: 20px;
    margin-bottom: 8px;
    text-align: center;
  }
  
  .price {
    font-size: 24px;
    margin-bottom: 16px;
    text-align: center;
    font-weight: bold;
  }
  
  .plan ul {
    font-size: 14px;
    margin-bottom: 20px;
    text-align: left;
  }
  
  .plan ul li {
    margin-bottom: 6px;
    line-height: 1.4;
  }
  
  .plan :deep(.btn) {
    position: static;
    margin-top: 16px;
    width: 100%;
    transform: none;
    left: auto;
    bottom: auto;
  }
}

@media (max-width: 480px) {
  .plan {
    max-width: 280px;
    padding: 20px;
  }
  
  .plan h3 {
    font-size: 18px;
    margin-bottom: 6px;
  }
  
  .price {
    font-size: 22px;
    margin-bottom: 14px;
  }
  
  .plan ul {
    font-size: 13px;
    margin-bottom: 18px;
  }
  
  .plan ul li {
    margin-bottom: 5px;
  }
}
</style> 